<template>
    <div class="form-input-wrapper">
      <slot></slot>
      <div class="error">
        <p class="small">{{errorText}}</p>
      </div>

    </div>
</template>

<script>
    //import comp from '@/path/to/comp.vue';    //от папки src указанной в webpack
    /**
     * @slots:
     * default, error
     *
     */
    export default {
      components: {

      },
      props: {
        errorText: String
      }
    }
</script>
<style scoped lang="scss">
    @import 'src/scss/vars';    //от папки со сборкой
    .form-input-wrapper{
      .error {
        height:calc( 24 * var(--px));
        /*outline: 1px solid darkred;*/
        display: flex;
        align-items:center;
        p {
          color: $clrErr;
          margin-bottom: 0;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/form-input-wrapper.vue